// extracted by mini-css-extract-plugin
export default {"notifyContainer":"notify_notifyContainer__GY5nE","cross":"notify_cross__ida93","notifyText":"notify_notifyText__dcQrP","btn":"notify_btn__A9Gu8","icon":"notify_icon__5Rjak"};